import styled from 'styled-components';

import hairBg from '../../../assets/hair.svg';

import media from '../../../styles/media.style';
import { BG_GRAY, MOBILE_PADDING, PAGE_WIDTH, SCREEN_LOCKUP_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 0 auto;

  h5 {
    position: relative;
    margin: 0 0 4em;
    text-align: center;
    text-transform: uppercase;

    &::after {
      content: '';
      position: absolute;
      bottom: -18px;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${BG_GRAY.COMMON_8};
      height: 3px;
      width: 40px;
    }
  }

  ${media.tabletL`
    align-items: center;
    margin: 0 auto 6em;
  `};
`;

export const SliderWrapper = styled.div`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 0 ${MOBILE_PADDING}px;
  width: 100%;
`;

export const ImageSlide = styled.div`
  width: 100%;
`;

export const Disclaimers = styled.div`
  min-height: 400px;
  background-color: ${BG_GRAY.COMMON_1};
  margin-top: -18em;
  background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};
  padding: 0 ${MOBILE_PADDING}px 4em;
`;

export const DisclaimersInner = styled.div`
  padding-top: 25em;
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
  color: #ccc;
  font-size: 16px;

  > h6 {
    margin: 0;
    span {
      text-transform: uppercase;
    }
  }

  ul {
    padding-left: 1em;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/SeminarGallery/SeminarGallery.style.js